Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconAlertFilledData: "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24'%3e%3cpath d='M23.42 19.37L14.51 1.52C14.02.58 13.06 0 12 0S9.98.58 9.48 1.54L.57 19.37c-.81 1.6-.39 2.72-.06 3.24.59.96 1.67 1.38 2.49 1.38h18.06c.79 0 1.85-.43 2.43-1.38.32-.53.75-1.65-.07-3.25zM11 10c0-.55.45-1 1-1s1 .45 1 1v4c0 .55-.45 1-1 1s-1-.45-1-1v-4zm1 9.5a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5z' fill='currentColor' stroke-width='0'/%3e%3c/svg%3e",
  iconAlertFilledWidth: 24,
  iconAlertFilledHeight: 24
};